var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3C2 2.20435 2.31607 1.44129 2.87868 0.87868C3.44129 0.31607 4.20435 0 5 0C5.79565 0 6.55871 0.31607 7.12132 0.87868C7.68393 1.44129 8 2.20435 8 3V8C8 8.79565 7.68393 9.55871 7.12132 10.1213C6.55871 10.6839 5.79565 11 5 11C4.20435 11 3.44129 10.6839 2.87868 10.1213C2.31607 9.55871 2 8.79565 2 8V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5C0.632608 6.5 0.759785 6.55268 0.853553 6.64645C0.947321 6.74021 1 6.86739 1 7V8C1 9.06087 1.42143 10.0783 2.17157 10.8284C2.92172 11.5786 3.93913 12 5 12C6.06087 12 7.07828 11.5786 7.82843 10.8284C8.57857 10.0783 9 9.06087 9 8V7C9 6.86739 9.05268 6.74021 9.14645 6.64645C9.24021 6.55268 9.36739 6.5 9.5 6.5C9.63261 6.5 9.75979 6.55268 9.85355 6.64645C9.94732 6.74021 10 6.86739 10 7V8C10 9.23953 9.53962 10.4349 8.70812 11.3541C7.87663 12.2734 6.73332 12.851 5.5 12.975V15H8.5C8.63261 15 8.75979 15.0527 8.85355 15.1464C8.94732 15.2402 9 15.3674 9 15.5C9 15.6326 8.94732 15.7598 8.85355 15.8536C8.75979 15.9473 8.63261 16 8.5 16H1.5C1.36739 16 1.24021 15.9473 1.14645 15.8536C1.05268 15.7598 1 15.6326 1 15.5C1 15.3674 1.05268 15.2402 1.14645 15.1464C1.24021 15.0527 1.36739 15 1.5 15H4.5V12.975C3.26668 12.851 2.12337 12.2734 1.29188 11.3541C0.460384 10.4349 -1.55717e-05 9.23953 3.95006e-10 8V7C3.95006e-10 6.86739 0.0526785 6.74021 0.146447 6.64645C0.240215 6.55268 0.367392 6.5 0.5 6.5Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/use.1ed61bcae6d68b3e7fc596a527d18ded.svg";